export const stripHtml = (html) => String(html ?? "").replace(/<[^>]*>/g, "").trim();

export function parseSpq(spq) {
  if (spq && typeof spq === "object") return spq;
  if (typeof spq !== "string") return null;
  try {
    const p = JSON.parse(spq);
    return p && typeof p === "object" ? p : null;
  } catch {
    return null;
  }
}

export function getClirnetSurveys(question) {
  if (!question || typeof question !== "object") return [];

  if (Object.keys(question).some((k) => /^question\d+$/i.test(k))) {
    const arr = Object.values(question).filter(Boolean);
    if (arr.length) return arr;
  }

  const candidates = [
    question.questions?.data?.questions?.surveys,
    question.questions?.data?.surveys,
    question.data?.questions?.surveys,
    question.data?.surveys,
    question.questions?.surveys,
    question.surveys,
    question.data,
  ];

  for (const c of candidates) {
    if (!c || typeof c !== "object") continue;
    if (!Array.isArray(c) && Object.keys(c).some((k) => /^question\d+$/i.test(k))) {
      const arr = Object.values(c).filter(Boolean);
      if (arr.length) return arr;
    }
    const arr = Array.isArray(c) ? c : Object.values(c);
    const list = arr.filter(Boolean);
    if (list.length) return list;
  }
  return [];
}

export function getClirnetSurveyOptions(survey) {
  const raw = survey?.options;
  if (!raw) return [];
  const arr = Array.isArray(raw) ? raw : Object.values(raw);
  return arr
    .filter((o) => o && typeof o === "object" && (o.label !== undefined || o.value !== undefined || o.text !== undefined))
    .map((o, i) => ({
      ...o,
      label: o.label != null ? String(o.label) : o.text != null ? String(o.text) : o.value != null ? String(o.value) : `Option ${i + 1}`,
      value: o.value != null ? o.value : i,
    }));
}

export const QUESTION_TYPES = {
  SINGLE: "single",
  BOOLEAN: "boolean",
  CONSENT: "consent",
  OTHER: "other",
  MULTIPLE: "multiple",
  IMAGE: "image",
  TEXT: "text",
  RANKING: "ranking",
  FILEUPLOAD: "fileupload",
};

const INSTANT_RADIO = new Set([QUESTION_TYPES.SINGLE, QUESTION_TYPES.BOOLEAN, QUESTION_TYPES.OTHER]);

export function getQuestionType(q) {
  const raw = typeof q?.type === "string" ? q.type.trim().toLowerCase() : "";
  return raw || QUESTION_TYPES.SINGLE;
}

export function isInstantRadioQuestion(q) {
  return INSTANT_RADIO.has(getQuestionType(q));
}

export function getOptionKey(opt, index) {
  return opt?.id != null ? `id:${opt.id}` : `idx:${index}`;
}

export function toRawOptionArray(survey) {
  const raw = survey?.options;
  if (!raw) return [];
  const arr = Array.isArray(raw) ? raw : Object.values(raw);
  return arr.filter(Boolean);
}

export function clirnetSurveyAnswerEntry(survey, selectedIndex) {
  return { ...survey, selectedIndex };
}

export function buildClirnetAnswerJson(answers) {
  return JSON.stringify(answers || []);
}

export function normalizeClirnetSurveys(question) {
  const first = getClirnetSurveys(question)[0];
  if (!first) return { question: "", options: [] };
  return {
    question: stripHtml(first.question),
    options: getClirnetSurveyOptions(first).map((o, i) => ({
      id: `opt_${i + 1}`,
      text: o.label,
      value: 0,
    })),
  };
}
